// Paths for route navigation

export const AUTH_REDIRECT = "/auth-redirect";
export const LOGIN = "/login";
export const PROFILE = "/profile";
export const STUDENT_PORTAL_PUBLIC = "/portal";
/** A Team members widget on its own page, outside the CRM (features/Dashboard/v2/liveBoard). */
export const LIVE_BOARD = "/live/:dimKey";
export const NOT_FOUND_PATH = "*";
